export default "__VITE_ASSET__Dccr9mnO__"